<template>
    <div class="section">
        <h1 class="title has-text-centered">Smittevern</h1>
        <p class="is-size-6">Arrangøren skal ha oversikt over hvem som er til stede, for å kunne bistå kommunen ved en eventuell senere smitteoppsporing etter smittevernloven § 3-6. Opplysningene vil ikke bli brukt til noe annet formål og vil bli slettet etter 10 dager.</p>
        <p class="is-size-6 avsnitt">En person må gjerne registrere flere personer i denne appen. Bare trykk på tilbakeknappen etter at skjemaet er sendt inn.</p>
        <form 
            name="smittevern" 
            id="smitte" 
            method="POST" 
            data-netlify="true" 
            data-netlify-honeypot="bot-field"
            >
            <input type="hidden" name="form-name" value="Smittevernlogg" />
            <p class="has-text-centered is-large avsnitt">
                <input class="input is-primary" type="text" placeholder="Fullt navn" name="Navn">
            </p>
            <p class="has-text-centered is-large" style="margin-top:5px;">
                <input class="input is-primary" type="text" placeholder="Telefonnummer" name="Telefon">
            </p>
            <p class="has-text-centered avsnitt">
                <a class="button is-success is-large"  @click="this.suksess">Registrer</a>
            </p>  
        </form>  
    </div>
</template>

<script>
export default {
    name: 'Smittevern', 
    methods: {
        suksess() {
            this.$buefy.toast.open({
                message: 'Takk!',
                type: 'is-success',
            })
            setTimeout(this.sendInn, 1000)
        },

        sendInn(){
            document.getElementById("smitte").submit();
        }
    }
}
</script>

<style scoped>
.avsnitt {
    margin-top: 4vw;
}
</style>